/**
 * Lightboard Widgets Index
 * 
 * Central export point for all Lightboard settings widgets.
 * Each widget is a self-contained, reusable component for editing
 * specific aspects of the site/page/carousel configuration.
 * 
 * @author Kai v3 (Lightboard Specialist)
 * @created 2025-10-13
 */

export { ProjectionSettingsWidget } from './ProjectionSettingsWidget';
export type { ProjectionSettingsProps } from './ProjectionSettingsWidget';

export { PageSettingsWidget } from './PageSettingsWidget';
export type { PageSettingsProps } from './PageSettingsWidget';

export { SiteSettingsWidget } from './SiteSettingsWidget';
export type { SiteSettingsProps } from './SiteSettingsWidget';

export { CarouselSettingsWidget } from './CarouselSettingsWidget';
export type { CarouselSettingsProps } from './CarouselSettingsWidget';

export { NavigationSettingsWidget } from './NavigationSettingsWidget';
export type { NavigationSettingsWidgetProps } from './NavigationSettingsWidget';
